import React, { useState, useEffect } from 'react'
import { Image } from '@ta-interaktiv/contentbricks'
import { FactDataInterface, FactSegmentEntries } from 'components/_data'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'

const Entry = ({ img, text }: { img?: string; text: string }) => {
  return (
    <li className='entry'>
      <div style={{ display: 'inline-block' }}>
        {img && <Image file={require('images/' + img)} />}
        <div className={img ? 'text' : 'text wide'}>{text}</div>
      </div>
    </li>
  )
}
const SEGMENT_MAP: {
  symptoms: string
  who: string
  causes: string
  treatment: string
} = {
  symptoms: 'Symptome',
  who: 'Wer ist betroffen?',
  causes: 'Ursachen',
  treatment: 'Behandlung'
}

interface TableProps {
  data: FactDataInterface
}
export const FactTable = ({ data }: TableProps) => {
  const [factData, setFactData] = useState<FactDataInterface>(data)
  useEffect(() => {
    setFactData(data)
  }, [data])
  return (
    <>
      {factData && (
        <div className='ui vertical fitted segment tableSegment'>
          <div className='ui  container'>
            <SymptomsSegment
              title={SEGMENT_MAP.symptoms}
              entries={factData.values[0].values}
            />
            <div className='ui stackable centered grid'>
              <OtherSegment
                title={SEGMENT_MAP.who}
                entries={factData.values[1].values}
              />
              <OtherSegment
                title={SEGMENT_MAP.causes}
                entries={factData.values[2].values}
              />
              <OtherSegment
                title={SEGMENT_MAP.treatment}
                entries={factData.values[3].values}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
const OtherSegment = ({
  title,
  entries
}: {
  title: string
  entries: FactSegmentEntries
}) => {
  return (
    <div className='five wide column otherSegments'>
      <div className='title'>{title}</div>{' '}
      <ul>
        {entries.map((e, j) => {
          return (
            <Entry
              key={j}
              img={
                e.hasImage === 'yes'
                  ? 'grafik_' +
                    e.headache +
                    '_' +
                    e.type +
                    '_' +
                    e.order +
                    '.svg'
                  : undefined
              }
              text={e.text}
            />
          )
        })}
      </ul>
    </div>
  )
}
const SymptomsSegment = ({
  title,
  entries
}: {
  title: string
  entries: FactSegmentEntries
}) => {
  return (
    <>
      <div className='ui stackable centered grid bordered'>
        <div className='fifteen wide column'>
          <div className='title'>{title}</div>
        </div>

        {entries.map((e, j) => {
          return (
            <div className='five wide column' key={j}>
              <Entry
                img={
                  e.hasImage === 'yes'
                    ? 'grafik_' +
                      e.headache +
                      '_' +
                      e.type +
                      '_' +
                      e.order +
                      '.svg'
                    : undefined
                }
                text={e.text}
              />
            </div>
          )
        })}
      </div>
    </>
  )
}
